import { createSlice } from "@reduxjs/toolkit";
import {
  addPointsForSectionStudents,
  addSectionToClass,
  editSection,
  getPointsForSectionStudents,
  getSectionsForClass,
  getTestGradesForSection,
  showResults,
} from "../services/section_service";
// ----------------------------------------------------------------------

const slice = createSlice({
  name: "section",

  initialState: {
    isLoadingAddSectionToClass: false,
    isLoadingGetSectionsForClass: false,
    sectionsForClass: [],
    sectionInfo: {},
    isLoadingEditSection: false,
    isLoadingPointsForSectionStudents: false,
    isLoadingGetTestGradesForSection: false,
    testGradesForSection: [],
    allResultForStudent: [],
    isLoadingAllResultForStudent: false,
  },

  reducers: {
    setSectionInfo: (state, action) => {
      state.sectionInfo = action.payload;
    },
  },

  extraReducers: {
    // POST ==> addSectionToClass
    [addSectionToClass.fulfilled]: (state, action) => {
      state.isLoadingAddSectionToClass = false;
    },
    [addSectionToClass.rejected]: (state, action) => {
      state.isLoadingAddSectionToClass = false;
    },
    [addSectionToClass.pending]: (state) => {
      state.isLoadingAddSectionToClass = true;
    },

    // GET ==> getSectionsForClass
    [getSectionsForClass.fulfilled]: (state, action) => {
      state.isLoadingGetSectionsForClass = false;
      state.sectionsForClass = action.payload.data.data;
    },
    [getSectionsForClass.rejected]: (state, action) => {
      state.isLoadingGetSectionsForClass = false;
    },
    [getSectionsForClass.pending]: (state) => {
      state.isLoadingGetSectionsForClass = true;
    },

    // GET ==> getSectionsForClass
    [editSection.fulfilled]: (state, action) => {
      state.isLoadingEditSection = false;
      // state.sectionsForClass = action.payload.data.data
    },
    [editSection.rejected]: (state, action) => {
      state.isLoadingEditSection = false;
    },
    [editSection.pending]: (state) => {
      state.isLoadingEditSection = true;
    },

    // GET ==> getPointsForSectionStudents
    [getPointsForSectionStudents.fulfilled]: (state, action) => {
      state.isLoadingPointsForSectionStudents = false;
      // state.sectionsForClass = action.payload.data.data
    },
    [getPointsForSectionStudents.rejected]: (state, action) => {
      state.isLoadingPointsForSectionStudents = false;
    },
    [getPointsForSectionStudents.pending]: (state) => {
      state.isLoadingPointsForSectionStudents = true;
    },

    // GET ==> getTestGradesForSection
    [getTestGradesForSection.fulfilled]: (state, action) => {
      state.isLoadingGetTestGradesForSection = false;
      state.testGradesForSection = action.payload.data.data;
    },
    [getTestGradesForSection.rejected]: (state, action) => {
      state.isLoadingGetTestGradesForSection = false;
    },
    [getTestGradesForSection.pending]: (state) => {
      state.isLoadingGetTestGradesForSection = true;
    },

    // GET ==> showResults
    [showResults.fulfilled]: (state, action) => {
      state.isLoadingAllResultForStudent = false;
      state.allResultForStudent = action.payload.data.grades;
    },
    [showResults.rejected]: (state, action) => {
      state.isLoadingAllResultForStudent = false;
    },
    [showResults.pending]: (state) => {
      state.isLoadingAllResultForStudent = true;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setSectionInfo } = slice.actions;
